/**
 * Determines if the URL is valid based on the standard Loom share URL pattern
 * @param shareUrl
 * @returns boolean
 * @example isUrlValid('https://www.loom.com/share/6d1794b0dd4c4a8495efa20d090c1602') // true
 * @example isUrlValid('https://stage.loom.com/share/Test-Recording-Video-9b7af208f71f45379a9f297bd065397a') // true
 * @example isUrlValid('https://www.youtube.com/watch?v=Hd0JflMdqyM') // false
 */
export const isUrlValid = (shareUrl: string): boolean => {
	// strip query string
	try {
		const loomShareUrlPattern =
			/^\s*http(s)?:\/\/(www\.|stage\.)?(loom.com)\/(embed|share)\/(.+-)?([a-fA-F0-9]{32})(?:\?|$)/;
		const url = new URL(shareUrl);
		url.search = '';
		return loomShareUrlPattern.test(url.toString());
	} catch {
		return false;
	}
};

/**
 * Determines if the error message should be shown based on the shareUrl
 * 	- Empty string should not show an error message
 *  - Undefined should show an error message
 *  - Invalid URL should show an error message
 * @param shareUrl
 * @returns boolean
 */
export const shouldShowInvalidMessage = (shareUrl: string | undefined): boolean => {
	if (shareUrl === '') {
		// we don't want to show an error message when the field is empty. especially when 'reset' is called after submitting, url is set to '' after that
		return false;
	}
	if (shareUrl === undefined) {
		return true;
	}

	return !isUrlValid(shareUrl);
};

/**
 * Determines if the URL can be inserted based on the shareUrl
 * 	- Empty string should not be inserted
 *  - Undefined should not be inserted
 *  - Invalid URL should not be inserted
 * @param shareUrl
 * @returns boolean
 */
export const canInsert = (url: string | undefined): boolean =>
	!shouldShowInvalidMessage(url) && url?.trim() !== '';
